import Vue from 'vue'

let modalReject
let modalResolve
export default {
  state: {
    showConfirmModal: false,
    student: null,
    confirmBody: 'Do you really want to do this?',
  },
  mutations: {
    UI_SET_CONFIRM_BODY (state, { value }) { state.confirmBody = value },
    UI_SET_SHOW_CONFIRM_MODAL (state, { value }) { state.showConfirmModal = value },
    UI_SET_STUDENT (state, { student }) { state.student = student },
    UI_SET_STUDENT_PROFILE (state, { profile }) {
      if (state.student) {
        state.student.profile = profile
      }
    },
  },
  actions: {
    UI_CONFIRM ({ commit }, { message }) {
      return new Promise((resolve, reject) => {
        if (message) {
          commit('UI_SET_CONFIRM_BODY', { value: message })
        }
        commit('UI_SET_SHOW_CONFIRM_MODAL', { value: true })
        modalResolve = resolve
        modalReject = reject
      })
    },
    UI_CONFIRM_CANCEL: ({ commit }) => {
      commit('UI_SET_SHOW_CONFIRM_MODAL', { value: false })
      modalReject()
    },
    UI_CONFIRM_OK: ({ commit }) => {
      commit('UI_SET_SHOW_CONFIRM_MODAL', { value: false })
      modalResolve()
    },
    UI_SET_STUDENT_PROFILE ({ state, commit }, { profile }) {
      commit('UI_SET_STUDENT_PROFILE', { profile })
      return Vue.http.put(`user/${state.student.id}`, state.student)
    },
  },
}
